<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <emblem>{{ 'NVB Medewerkers' }}</emblem>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col col-md-6 col-lg-4">
                <div class="search-input">
                    <div class="search-input__container">
                        <input
                            v-model="searchQuery"
                            class="search-input__field w-100"
                            type="search"
                            :placeholder="
                                '   Zoeken op ' + translations.focusAreas
                            "
                        />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="loading" class="row">
            <div class="col text-center mt-3 mb-3">
                <div class="emblem emblem--loader"></div>
            </div>
        </div>
        <v-collapse-group :only-one-active="true">
            <transition-group
                tag="div"
                name="staggered-fade"
                :css="false"
                class="row"
                @before-enter="beforeEnter"
                @enter="enter"
                @leave="leave"
            >
                <v-collapse-wrapper
                    v-for="(cardData, index) in searchResults"
                    :key="cardData.id"
                    class="col-lg-4 col-sm-6 mb-3"
                >
                    <member-card
                        :card-data="cardData"
                        :data-index="index"
                        :read-more="translations.focusAreas"
                    >
                    </member-card>
                </v-collapse-wrapper>
            </transition-group>
        </v-collapse-group>

        <div v-show="emptyResult" class="col text-center">
            {{ translations.emptyResult }}
        </div>
    </div>
</template>

<style lang="scss" scoped>
.search-input {
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
}

.search-input__field {
    height: 40px;
}
</style>

<script>
import Axios from 'axios';
import emblem from '@/components/emblem';
import memberCard from '@/components/members/member-card';
import overview from '@/mixins/overview.js';
import transition_staggered_fade from '@/mixins/transition-staggered-fade-mixin.js';
import translationMixin from '@/mixins/translations';

export default {
    components: {
        emblem,
        memberCard
    },

    mixins: [overview, transition_staggered_fade, translationMixin],

    created() {
        this.getItems();
    },

    methods: {
        getItems() {
            clearInterval(this.elapsed);
            this.loading = true;
            this.searchResults = [];
            const getUrl = '/api/v1/domainapi/employees?q=' + this.searchQuery;
            Axios.get(getUrl).then(response => {
                if (response.status == 200 && response.data) {
                    this.searchResults = response.data;
                    this.emptyResult =
                        response.data.results != 0 ? false : true;
                }
                this.loading = false;
            });
        }
    }
};
</script>
